import { Route, Switch } from 'react-router-dom'
import { ROUTER_PATH } from './metaData'

// Common
import NotFoundPage from '../404/NotFoundPage'
import ProfileScreen from '../profile'

import AccountScreen from '../account'
import AccountCreateScreen from '../account/form'
import TripScreen from '../trip'
import TripCreateScreen from '../trip/form'
import DefaultSaleScreen from '../default/DefaultSaleScreen'

const SaleRouters = (props: any) => {
   return (
      <Switch>
         {/* Common */}
         <Route exact path={`/`} component={DefaultSaleScreen} />
         <Route exact path={`${props.match.url}${ROUTER_PATH.ProfileScreen}`} component={ProfileScreen} />
         <Route exact path={`${props.match.url}${ROUTER_PATH.AccountScreen}`} component={AccountScreen} />
         <Route exact path={`${props.match.url}${ROUTER_PATH.AccountCreateScreen}`} component={AccountCreateScreen} />
         <Route exact path={`${props.match.url}${ROUTER_PATH.AccountUpdateScreen}`} component={AccountCreateScreen} />
         <Route exact path={`${props.match.url}${ROUTER_PATH.AccountDetailScreen}`} component={AccountCreateScreen} />
         {/* <Route exact path={`${props.match.url}${ROUTER_PATH.FundScreen}`} component={FundScreen} />
         <Route exact path={`${props.match.url}${ROUTER_PATH.FundCreateScreen}`} component={FundCreateScreen} />
         <Route exact path={`${props.match.url}${ROUTER_PATH.FundUpdateScreen}`} component={FundCreateScreen} />
         <Route exact path={`${props.match.url}${ROUTER_PATH.FundDetailScreen}`} component={FundCreateScreen} />

         <Route exact path={`${props.match.url}${ROUTER_PATH.PromotionScreen}`} component={PromotionScreen} />
         <Route
            exact
            path={`${props.match.url}${ROUTER_PATH.PromotionCreateScreen}`}
            component={PromotionCreateScreen}
         /> */}
         {/* <Route
            exact
            path={`${props.match.url}${ROUTER_PATH.PromotionUpdateScreen}`}
            component={PromotionCreateScreen}
         />
         <Route
            exact
            path={`${props.match.url}${ROUTER_PATH.PromotionDetailScreen}`}
            component={PromotionCreateScreen} 
         />*/}
         {/* <Route exact path={`${props.match.url}${ROUTER_PATH.CommonConfigScreen}`} component={CommonConfigScreen} />
         <Route exact path={`${props.match.url}${ROUTER_PATH.PriceScreen}`} component={PriceScreen} /> */}
         <Route exact path={`${props.match.url}${ROUTER_PATH.TripScreen}`} component={TripScreen} />
         <Route exact path={`${props.match.url}${ROUTER_PATH.TripCreateScreen}`} component={TripCreateScreen} />
         <Route exact path={`${props.match.url}${ROUTER_PATH.TripUpdateScreen}`} component={TripCreateScreen} />
         <Route exact path={`${props.match.url}${ROUTER_PATH.TripDetailScreen}`} component={TripCreateScreen} />

         {/* <Route exact path={`${props.match.url}${ROUTER_PATH.ProvinceScreen}`} component={ProvinceScreen} />
         <Route exact path={`${props.match.url}${ROUTER_PATH.ProvinceCreateScreen}`} component={ProvinceCreateScreen} />
         <Route exact path={`${props.match.url}${ROUTER_PATH.ProvinceUpdateScreen}`} component={ProvinceCreateScreen} />
         <Route exact path={`${props.match.url}${ROUTER_PATH.ProvinceDetailScreen}`} component={ProvinceCreateScreen} />

         <Route exact path={`${props.match.url}${ROUTER_PATH.LocationScreen}`} component={LocationScreen} />
         <Route exact path={`${props.match.url}${ROUTER_PATH.LocationCreateScreen}`} component={LocationCreateScreen} />
         <Route exact path={`${props.match.url}${ROUTER_PATH.LocationUpdateScreen}`} component={LocationCreateScreen} />
         <Route exact path={`${props.match.url}${ROUTER_PATH.LocationDetailScreen}`} component={LocationCreateScreen} /> */}
         {/* Not Found */}
         <Route path="*" component={NotFoundPage} />
      </Switch>
   )
}

export default SaleRouters
